import React, { useState } from "react";
import styles from "./header.module.css";
import logo from "../../assets/images/cairo capital logo-03 (1) copy.png";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className={styles.header}>
      <div className={styles.logoContainer}>
        <img src={logo} alt="Cairo Capital" className={styles.logo} />
      </div>
    </header>
  );
};

export default Header;
